import styled, { css } from 'styled-components';

import { UpdateMessage } from 'libs/ui';

export const Content = styled.div`
  width: 590px;
  position: relative;
  form > div:last-child {
    margin-top: 20px;
  }
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      width: 100%;
    `}
`;

export const UpdateMessageStyled = styled(UpdateMessage)`
  bottom: -40px;
  left: 100px;
  z-index: 1;
`;

export const Title = styled.p`
  border-bottom: solid 1px var(--cp-border, #595d64);
  padding: 0 0 15px 0;
  font-size: 20px;
  color: var(--cp-text, #fff);
  opacity: 0.6;
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      font-size: 16px;
      font-weight: 600;
      opacity: 1;
      padding-bottom: 12px;
      margin-bottom: 6px;
    `}
`;